<template>
  <div>
    <loginheader></loginheader>
    <div class="mypasswordcg">
      <div class="mypasswordcg-div">
        <img src="../../img/grzx.png" alt="" class="mypasswordcg-img">
        <p class="mypasswordcg-p">用户昵称</p>
        <p class="mypasswordcg-p1">密码修改成功</p>
        <router-link to="/login">
          <p class="mypasswordcg-p2">点击回到首页</p>
        </router-link>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
  import loginheader from '../loginheader.vue'
  import Fotter from '../Fotter.vue'

  export default {
    name: 'App',
    props: ['flag'],
    components: {
      loginheader,
      Fotter,
    },


  }
</script>

<style scoped="scoped">

  .mypasswordcg {
    width: 100%;
  }

  .mypasswordcg-div {
    width: 150px;
    margin: 175px auto 0;
  }

  .mypasswordcg-img {
    width: 138px;
    height: 138px;
    margin: 0 auto;
  }

  .mypasswordcg-p {
    font-size: 16px;
    text-align: center;
    margin-top: 37px;
  }

  .mypasswordcg-p1 {
    margin-top: 70px;
    text-align: center;
    color: #28A3B1;
    font-size: 16px;
  }

  .mypasswordcg-p2 {
    margin-top: 16px;
    text-align: center;
    color: #28A3B1;
    font-size: 16px;
    margin-bottom: 286px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/mypasswordcg.vue